import React, { useState, useEffect } from "react";
import "./EditUser.styles.scss";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { TRUE } from "sass";
import { Collapse } from "@mui/material";
function PasswordInputField({
  handleValidation,
  handlePasswordChange,
  passwordValue,
  passwordError,
  hidePass,
}) {
  return (
    <div className="password-group">
      <input
        type={hidePass ? "password" : "text"}
        value={passwordValue}
        onChange={handlePasswordChange}
        onKeyUp={handleValidation}
        name="password"
        placeholder="Password"
        autoComplete="off"
      />
      <Collapse in={passwordError.length > 0}>{passwordError}</Collapse>
    </div>
  );
}

function ConfirmPasswordInputField({
  handleValidation,
  handlePasswordChange,
  confirmPasswordValue,
  confirmPasswordError,
  hidePass,
}) {
  return (
    <div className="password-group">
      <input
        value={confirmPasswordValue}
        onChange={handlePasswordChange}
        onKeyUp={handleValidation}
        name="confirmPassword"
        placeholder="Password"
        type={hidePass ? "password" : "text"}
        autoComplete="off"
      />
      <Collapse in={confirmPasswordError.length > 0}>
        {confirmPasswordError}
      </Collapse>
    </div>
  );
}

function PasswordAndConfirmPasswordValidation({
  callBack,
  closeModal,
  isCreatingModal,
}) {
  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordInput, setPasswordInput] = useState({
    password: "",
    confirmPassword: "",
  });
  const [hidePass, setHidePass] = useState(true);

  const toggleHidePass = (e) => {
    e.preventDefault();
    setHidePass(!hidePass);
  };
  const callBackForPassWordChange = () => {
    callBack(passwordInput.password);
    closeModal();
  };
  const handlePasswordChange = (evnt) => {
    evnt.preventDefault();
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    const NewPasswordInput = {
      ...passwordInput,
      [passwordInputFieldName]: passwordInputValue,
    };
    setPasswordInput(NewPasswordInput);
  };
  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim();
    const passwordInputFieldName = evnt.target.name;
    //for password
    if (passwordInputFieldName === "password") {
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp = /.{8,}/;
      const passwordLength = passwordInputValue.length;
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
      const digitsPassword = digitsRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword = minLengthRegExp.test(passwordInputValue);
      let errMsg = "";
      if (passwordLength === 0) {
        errMsg = "Password is empty";
      } else if (!uppercasePassword) {
        errMsg = "At least one Uppercase";
      } else if (!lowercasePassword) {
        errMsg = "At least one Lowercase";
      } else if (!digitsPassword) {
        errMsg = "At least one digit";
      } else if (!specialCharPassword) {
        errMsg = "At least one Special Characters";
      } else if (!minLengthPassword) {
        errMsg = "At least minumum 8 characters";
      } else {
        errMsg = "";
      }
      setPasswordErr(errMsg);
    }
    // for confirm password
    if (
      passwordInputFieldName === "confirmPassword" ||
      (passwordInputFieldName === "password" &&
        passwordInput.confirmPassword.length > 0)
    ) {
      if (passwordInput.confirmPassword !== passwordInput.password) {
        setConfirmPasswordError("Confirm password is not matched");
      } else {
        setConfirmPasswordError("");
      }
    }

    if (
      passwordInput.password.length !== 0 &&
      passwordInput.confirmPassword.length !== 0 &&
      passwordInput.password === passwordInput.confirmPassword
    )
      callBack(passwordInput.password);
    else callBack("");
  };
  const disabledSave = !(
    !passwordError &&
    !confirmPasswordError &&
    passwordInput.password &&
    passwordInput.confirmPassword
  );
  return (
    <div>
      <div style={{ paddingLeft: 12 }}>
        <button
          onClick={toggleHidePass}
          style={{ background: "white", borderRadius: 5, marginBottom: 10 }}
        >
          {hidePass ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </button>
        <PasswordInputField
          handlePasswordChange={handlePasswordChange}
          handleValidation={handleValidation}
          passwordValue={passwordInput.password}
          passwordError={passwordError}
          hidePass={hidePass}
        />
        <ConfirmPasswordInputField
          handlePasswordChange={handlePasswordChange}
          handleValidation={handleValidation}
          confirmPasswordValue={passwordInput.confirmPassword}
          confirmPasswordError={confirmPasswordError}
          hidePass={hidePass}
        />
      </div>
      {!isCreatingModal && (
        <div className="btn-container">
          <button className="button--cancel" onClick={closeModal}>
            {" "}
            Cancel{" "}
          </button>
          <button
            className={disabledSave ? "button--save-disabled" : "button--save"}
            disabled={disabledSave}
            onClick={callBackForPassWordChange}
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
}

export default PasswordAndConfirmPasswordValidation;
